<div class="dialog-container">
  <div class="dialog-header">
      <h2 class="dialog-title">Envoi automatique du rapport</h2>
    <div>
   <button mat-icon-button class="icon-btn" (click)="openList()" title="Liste">
  <i class="fa fa-envelope"></i>
</button>
<button mat-icon-button class="icon-btn" (click)="dialogRef.close()" title="Fermer">
  <i class="fa fa-times"></i>
</button>
    </div>
  </div>

  <div class="dialog-body">
    <div class="field-group">
      <label for="title">Titre</label>
      <input id="title" type="text" [(ngModel)]="title" name="title" placeholder="Titre du rapport">
    </div>

    <div class="field-group">
      <label for="email">Email</label>
      <input id="email" type="email" [(ngModel)]="email" name="email" placeholder="exemple@email.com">
    </div>

    <div class="field-group">
      <label for="frequence">Période</label>
      <select id="frequence" [(ngModel)]="frequence" name="frequence">
      <option
      *ngFor="let opt of availablePeriodOptions"
      [value]="opt.value">
      {{ opt.label }}
    </option>
      </select>
    </div>
  </div>

  <div class="dialog-footer">
  <button
    class="save-btn"
    [disabled]="isSending"
    [class.is-loading]="isSending"
    (click)="saveAutoReport()">

    <span class="spinner" *ngIf="isSending"></span>

    <span>{{ isSending ? 'Enregistrement...' : 'Enregistrer' }}</span>
  </button>
</div>